import React, { useContext } from 'react';
import { IndexContext } from '../../context'

const Journey = ({ journeySec, styles = {} }) => {
  const { baseUrl } = useContext(IndexContext);

  return (
    <div className="index-journey-atp">
      <figure className="index-curve-first-figure">
        <svg width="115px" height="77px" className="">
          <use href={baseUrl + "/public/images/shapes.svg#FareHarbor"}/>
        </svg>
      </figure>
      <small className="index-how-works-small small-text-center">
        Tour bookings are made on the Fareharbor network{' '}
      </small>
      <figure className="index-curve-second-figure">
        <svg width="185px" height="135px">
          <use href={baseUrl + "/public/images/shapes.svg#VectorArrow"}/>
        </svg>
      </figure>
      <figure className="index-curve-third-figure">
        <svg width="143px" height="104px" className="svg-sprite doted-curve-svg">
          <use href={baseUrl + "/public/images/shapes.svg#arrowNew"}/>
        </svg>
      </figure>
      <small className="index-how-works-small small-text-center">
        The flight or tour is seamlessly scheduled on AirTourPro complete with passenger information
      </small>
      <small className="index-how-works-small small-text-center">
        Weight and balance is checked and managed
      </small>
      <small className="index-how-works-small small-text-center">
        The manifest is generated and printed on AirTourPro to dispatch aircraft
      </small>
      <figure className="index-curve-fourth-figure">
        <svg width="190px" height="120px" className="svg-sprite doted-curve-svg">
          <use href={baseUrl + "/public/images/shapes.svg#arrow3"}/>
        </svg>
      </figure>
      <a
        href={journeySec.extLinkBtn}
        target="_blank"
      >
        <button
          type="button"
          className={`btn-orange ${styles.btn}`}
          children={journeySec.extLinkBtnName}
        />
      </a>
    </div>
  );
};

export default Journey;
